/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ITestProcessEventScope extends angular.IScope {
        model: any;
    }

    export class TestProcessEventController implements IController {
        constructor(
            private $scope: ITestProcessEventScope,
            private testService: services.TestService)
        {
            $scope.model = {};
            $scope.model.setProcessEventToCurrentValue = () => { this.setProcessEventToCurrentValue(); }
            $scope.model.rollback = () => { this.rollback(); }
        }

        private setProcessEventToCurrentValue() : void {
            this.testService.getCurrentProcessEventMaxId(this.$scope.model.processId).then((max) => {
                this.$scope.model.processEventId = max;
            });
        }

        private rollback(): void {
            this.testService.rollbackProcess(this.$scope.model.processId, this.$scope.model.processEventId).then(() => {
                alert("Process Reverted!");
            });
        }
    }
}

warsApp.registerController("TestProcessEventController", ["$scope", "testService"]);